import { combineReducers } from "redux";
import flashMessages from "./reducers/flashMessages";
import auth from "./reducers/auth";
import product from "./reducers/product";
import country from "./reducers/country";
import cart from "./reducers/cart";
import order from "./reducers/order";
import storeAddress from "./reducers/storeAddress";
import autoRenewal from "./reducers/autoRenewal";
export default combineReducers({
  flashMessages,
  auth,
  product,
  country,
  cart,
  order,
  storeAddress,
  autoRenewal
});



// WEBPACK FOOTER //
// ./src/modules/index.js